import React from "react";
import {
  useBusinessArea,
  useProject,
  useProjectType,
} from "../../../../Hooks/EntityHooks";
import {
  HistoryHeader,
  HistoryContent,
  HistoryAccountProfile,
  HistoryOverview,
  useHistoryItem,
} from "./HistoryItemCommon";
import { ConnectedProjectOrigin } from "../../../../Containers/Origin/ProjectOrigin";
import { createItemEditDetailsComponent } from "./HistoryItemDetails/HistoryItemDetails";
import { ProjectStatusProfile } from "../../../Projects/ProjectProfile";
import { FormattedMessage } from "react-intl";

const ProjectHistoryOverview = () => {
  const { Project, IsCreation, Account } = useHistoryItem();
  const item = useProject(Project);
  const { Name } = item;
  if (IsCreation)
    return (
      <HistoryOverview>
        <HistoryAccountProfile account={Account} />
        <span>
          {" "}
          <FormattedMessage id={"CREATED_PROJECT"} />{" "}
        </span>{" "}
        <b>{Name}</b>
      </HistoryOverview>
    );

  return (
    <HistoryOverview>
      <HistoryAccountProfile account={Account} />
      <span>
        {" "}
        <FormattedMessage id={"EDITED_PROJECT"} />{" "}
      </span>{" "}
      <b>{Name}</b>
    </HistoryOverview>
  );
};

// histórico pode trazer o id ou o objeto da área
const BusinessAreaValue = ({ value }) => {
  const area = useBusinessArea(value?.Id ?? value);
  return <span>{value?.Name ?? area?.Name ?? "-"}</span>;
};

// histórico já traz o Name como "Tipo - Nome"; o store tem Type e Name separados
const ProjectTypeValue = ({ value }) => {
  const type = useProjectType(value?.Id ?? value);
  if (value?.Name) return <span>{value.Name}</span>;
  return <span>{type ? `${type.Type} - ${type.Name}` : "-"}</span>;
};

const ProjectEditItemDetails = createItemEditDetailsComponent({
  Status: {
    NameId: "status",
    ValueComponent: ProjectStatusProfile,
  },
  BusinessArea: {
    NameId: "BUSINESS_AREA",
    ValueComponent: BusinessAreaValue,
  },
  ProjectType: {
    NameId: "TYPE",
    ValueComponent: ProjectTypeValue,
  },
});

const ProjectHistoryDetails = () => {
  const { IsCreation } = useHistoryItem();
  if (IsCreation) return null;

  return <ProjectEditItemDetails />;
};

const ProjectHistoryItem = () => {
  const { Project } = useHistoryItem();

  return (
    <>
      <HistoryHeader>
        <ConnectedProjectOrigin project={Project}>
          {/* <HistoryTitle Icon={ProjectIcon}>
            <FormattedMessage id={"PROJECT"} /> {Project}
          </HistoryTitle> */}
        </ConnectedProjectOrigin>
      </HistoryHeader>
      <HistoryContent>
        <ProjectHistoryOverview />
        <ProjectHistoryDetails />
      </HistoryContent>
    </>
  );
};
export default ProjectHistoryItem;
